import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import EmbedCodeContainer from 'asset-actions-lib-forms/share/components/EmbedCodeContainer';
import ShareLink from 'asset-actions-lib-forms/share/components/ShareLink';
import HubspotTab from 'asset-actions-lib-forms/share/components/HubSpotTab';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ShareTabbedViewWithHubspot({
  embedType,
  formGuid,
  formName,
  onClickCMSRoute,
  onClickCTARoute,
  onClickPreviewShareLink,
  onClose,
  onCopyEmbedCode,
  onCopyShareLink
}) {
  return /*#__PURE__*/_jsxs(Tabs, {
    "data-test-id": "share-tabbed-view-with-hubspot",
    defaultSelected: embedType === 'SHAREABLE' ? '2' : '1',
    children: [/*#__PURE__*/_jsx(Tab, {
      "data-test-id": "embedCodeTab",
      tabId: "1",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.embedCode.title"
      }),
      children: /*#__PURE__*/_jsx(EmbedCodeContainer, {
        formGuid: formGuid,
        formName: formName,
        onClose: onClose,
        onCopy: onCopyEmbedCode
      })
    }), /*#__PURE__*/_jsx(Tab, {
      "data-test-id": "shareLinkTab",
      tabId: "2",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.shareLink.title"
      }),
      children: /*#__PURE__*/_jsx(ShareLink, {
        formGuid: formGuid,
        onCopyShareLink: onCopyShareLink,
        onClickPreviewLink: onClickPreviewShareLink
      })
    }), /*#__PURE__*/_jsx(Tab, {
      "data-test-id": "hubspotTab",
      tabId: "3",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.hubspotTab.title"
      }),
      children: /*#__PURE__*/_jsx(HubspotTab, {
        onClickCTARoute: onClickCTARoute,
        onClickCMSRoute: onClickCMSRoute
      })
    })]
  });
}